import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRowingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.708 0C15.422 0 16 .578 16 1.292v.341c0 .289-.097.57-.275.797l-1.226 1.564A2.625 2.625 0 0112.433 5H9.929L8.795 6.443l2.361 3.005.686-.59.815.948-.728.626 3.522 4.483-.983.772-3.488-4.44-.722.621-.815-.948.764-.656L8 7.454l-2.207 2.81.764.656-.815.948-.722-.62-3.488 4.439-.983-.772 3.522-4.483-.728-.626.815-.948.686.59 2.361-3.005L6.071 5H3.567C2.761 5 2 4.63 1.501 3.994L.275 2.43A1.292 1.292 0 010 1.633v-.341C0 .578.578 0 1.292 0h1.88c.4 0 .78.187 1.024.506L6.87 3.994 8 5.432l1.136-1.446 2.668-3.48A1.292 1.292 0 0112.829 0zm.042 1.292a.042.042 0 00-.042-.042h-1.88a.042.042 0 00-.032.016L10.892 3.75h1.54c.423 0 .822-.194 1.083-.527l1.226-1.564a.042.042 0 00.01-.026zM1.292 1.25a.042.042 0 00-.042.042v.341c0 .01.003.018.009.026l1.226 1.564c.26.333.66.527 1.082.527h1.541L3.204 1.266a.042.042 0 00-.033-.016z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRowingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRowingNormalXsmall;
